module.exports = __webpack_public_path__ + "img/gal-03.b5a5b15b.png";